import { Sunrise, Sunset, Coffee, Dumbbell, Crosshair } from "lucide-react";

export const ROUTINE_TYPES = [
  { key: "pre_practice",  label: "Pre-Practice",      Icon: Sunrise,   accent: "#d8b854" },
  { key: "post_practice", label: "Post-Practice",     Icon: Sunset,    accent: "#c084fc" },
  { key: "off_light",     label: "Off Days · Light",  Icon: Coffee,    accent: "#60a5fa" },
  { key: "off_full",      label: "Off Days · Full",   Icon: Dumbbell,  accent: "#f59e0b" },
  { key: "shooting",      label: "Shooting Routines", Icon: Crosshair, accent: "#d8b854" },
];
export const TYPE_BY_KEY = Object.fromEntries(ROUTINE_TYPES.map(t => [t.key, t]));
export const UNIT_OPTIONS = [
  { value: "reps", label: "Makes / Reps" },
  { value: "seconds", label: "Seconds" },
  { value: "minutes", label: "Minutes" },
  { value: "sets_reps", label: "Sets × Reps" },
];
export const unitLabel = (u) => u === "reps" ? "makes" : u === "seconds" ? "sec" : u === "minutes" ? "min" : "";
export const blankDrill = () => ({ name: "", description: "", video_url: "", unit: "reps", value: "" });
